/**
 * Rutas estáticas del módulo Comercial (dentro de SOS).
 */
const sosComercial = (file) => () =>
  import("../views/sos/comercial/" + file + ".vue");

const comercialRoutes = [
  {
    path: "/Sos/Comercial/Dashboard",
    name: "ComercialDashboard",
    component: sosComercial("ComercialDashboard"),
  },
  {
    path: "/Sos/Comercial/MiDia",
    name: "ComercialMiDia",
    component: sosComercial("MiDia"),
  },
  {
    path: "/Sos/Comercial",
    name: "Comercial",
    redirect: { name: "ComercialDashboard" },
  },
  {
    path: "/Sos/Comercial/Empresas",
    name: "/Sos/Comercial/Empresas",
    component: sosComercial("empresas/EmpresaComercialIndex"),
  },
  {
    path: "/Sos/Comercial/Empresas/:id",
    name: "ComercialEmpresaDetalle",
    component: sosComercial("empresas/EmpresaComercialDetalle"),
  },
  {
    path: "/Sos/Comercial/Leads",
    name: "/Sos/Comercial/Leads",
    component: sosComercial("leads/LeadIndex"),
  },
  {
    path: "/Sos/Comercial/Oportunidades",
    name: "/Sos/Comercial/Oportunidades",
    component: sosComercial("oportunidades/OportunidadKanban"),
  },
  {
    path: "/Sos/Comercial/Cotizaciones",
    name: "/Sos/Comercial/Cotizaciones",
    component: sosComercial("cotizaciones/CotizacionIndex"),
  },
  {
    path: "/Sos/Comercial/Cotizaciones/Form/:id",
    name: "ComercialCotizacionForm",
    component: sosComercial("cotizaciones/CotizacionForm"),
  },
  {
    path: "/Sos/Comercial/Productos",
    name: "/Sos/Comercial/Productos",
    component: sosComercial("productos/ProductoIndex"),
  },
  {
    path: "/Sos/Comercial/Tarifarios",
    name: "/Sos/Comercial/Tarifarios",
    component: sosComercial("tarifarios/TarifarioIndex"),
  },
  {
    path: "/Sos/Comercial/Tarifarios/:id",
    name: "ComercialTarifarioDetalle",
    component: sosComercial("tarifarios/TarifarioDetalle"),
  },
  {
    path: "/Sos/Comercial/Contratos",
    name: "/Sos/Comercial/Contratos",
    component: sosComercial("contratos/ContratoIndex"),
  },
  {
    path: "/Sos/Comercial/Contratos/Form/:id",
    name: "ComercialContratoForm",
    component: sosComercial("contratos/ContratoForm"),
  },
  {
    path: "/Sos/Comercial/Config/Etapas",
    name: "/Sos/Comercial/Config/Etapas",
    component: sosComercial("config/EtapaPipelineIndex"),
  },
  {
    path: "/Sos/Comercial/Consultas/Reportes",
    name: "/Sos/Comercial/Consultas/Reportes",
    component: sosComercial("consultas/reportes/ReportesIndex"),
  },
  {
    path: "/Sos/Comercial/Reportes",
    redirect: "/Sos/Comercial/Consultas/Reportes",
  },
  {
    path: "/Sos/Comercial/Almacenamiento",
    name: "/Sos/Comercial/Almacenamiento",
    component: () =>
      import("../views/sos/comercial/almacenamiento/AlmacenamientoIndex.vue"),
  },
  // Compatibilidad: URLs antiguas /Comercial/...
  { path: "/Comercial", redirect: "/Sos/Comercial/Dashboard" },
  { path: "/Comercial/Dashboard", redirect: "/Sos/Comercial/Dashboard" },
  { path: "/Comercial/MiDia", redirect: "/Sos/Comercial/MiDia" },
  { path: "/Comercial/Empresas", redirect: "/Sos/Comercial/Empresas" },
  {
    path: "/Comercial/Empresas/:id",
    redirect: (to) => `/Sos/Comercial/Empresas/${to.params.id}`,
  },
  { path: "/Comercial/Leads", redirect: "/Sos/Comercial/Leads" },
  { path: "/Comercial/Oportunidades", redirect: "/Sos/Comercial/Oportunidades" },
  { path: "/Comercial/Cotizaciones", redirect: "/Sos/Comercial/Cotizaciones" },
  {
    path: "/Comercial/Cotizaciones/Form/:id",
    redirect: (to) => `/Sos/Comercial/Cotizaciones/Form/${to.params.id}`,
  },
  { path: "/Comercial/Productos", redirect: "/Sos/Comercial/Productos" },
  { path: "/Comercial/Tarifarios", redirect: "/Sos/Comercial/Tarifarios" },
  {
    path: "/Comercial/Tarifarios/:id",
    redirect: (to) => `/Sos/Comercial/Tarifarios/${to.params.id}`,
  },
  { path: "/Comercial/Contratos", redirect: "/Sos/Comercial/Contratos" },
  {
    path: "/Comercial/Contratos/Form/:id",
    redirect: (to) => `/Sos/Comercial/Contratos/Form/${to.params.id}`,
  },
  { path: "/Comercial/Config/Etapas", redirect: "/Sos/Comercial/Config/Etapas" },
  { path: "/Comercial/Reportes", redirect: "/Sos/Comercial/Consultas/Reportes" },
  { path: "/Comercial/Almacenamiento", redirect: "/Sos/Comercial/Almacenamiento" },
];

export function isComercialStaticRoute(path) {
  const p = String(path || "");
  return (
    p === "/Comercial" ||
    p.startsWith("/Comercial/") ||
    p === "/Sos/Comercial" ||
    p.startsWith("/Sos/Comercial/")
  );
}

export default comercialRoutes;
